(function () {
  var attempts = 0;
  var maxAttempts = 50;

  function tryFlush() {
    if (window.FP && window.FP._flush && window.FP._flush()) {
      return;
    }
    attempts += 1;
    if (attempts < maxAttempts) {
      window.setTimeout(tryFlush, 50);
    }
  }

  tryFlush();
})();
